const { get, getRawDoc, getRawDocByIds, listAll, getRawDocByWarehouseCodes, listIdsByLevels, getRawDocBySignupUid } = require('./read')
const { listWarehouseCodes } = require('./list-warehouse-codes')
const { update, updateContactPhone } = require('./write')

module.exports = { get, getRawDoc, getRawDocByIds, listAll, update, listWarehouseCodes, getRawDocByWarehouseCodes, listIdsByLevels, getRawDocBySignupUid, updateContactPhone }
